export function deduceVirginIds(childrenIds, children) {
    const virgins = [];

    if(children===null)
        return childrenIds;

    for(let i of childrenIds) {
        if(!checkIfIdIsInChildren(i, children)) {
            virgins.push(i);
        }
    }
    

    return virgins;
}

export function createIdsForRevealFromVirgins(virgins, revealAmount) {
    const toRevealArray = [];
    const toRevealLaterArray = [];
    
    for(let i in virgins) {
        
        if(i<revealAmount) {
            toRevealArray.push(virgins[i]);
        } else {
            toRevealLaterArray.push(virgins[i]);
        }
    }

    const idsObject = {
        toReveal : toRevealArray,
        toRevealLater : toRevealLaterArray
    }
    

    return idsObject;
}

function checkIfIdIsInChildren(id, children) {
    for(let i of children) {
        if(i.id===id) {
            return true;
        }
    }

    return false;
}